import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import Copyright from '../../components/Copyrights/copyrights';
import BackgroundUcl from '../../assets/Images/bg_ucl2.gif';
import NucleusLogo from '../../assets/Images/nUCLeus_logo.jpg';
import Typography from '@mui/material/Typography';
import EmailVerification from './Chunks/EmailVerification';
import CodeVerification from './Chunks/CodeVerification';
import ChangePassword from './Chunks/ChangePassword';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage: `url(${BackgroundUcl})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        height: '100%',

        //backgroundPosition: 'center',
    },
    image_logo: {
        backgroundImage: `url(${NucleusLogo})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        // backgroundColor:
        //   theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        // backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100px',
        width: '230px'

    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: '80%'
    },
    paper: {
        margin: theme.spacing(2, 2),
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        alignItems: 'center',


    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '90%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const ForgotPassword = () => {
    const classes = useStyles();
    // eslint-disable-next-line no-unused-vars
    const [viewValue, setViewValue] = useState(0);

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={12} md={12} className={classes.image} >
                <Grid container justifyContent="space-between" className={classes.root}>
                    <Grid item xs={false} sm={5} md={6} justifyContent="space-between" elevation={6} square style={{ textAlign: 'center', marginLeft: '2%', marginTop: '12%' }}>

                        <Typography variant="h2" style={{ textAlign: 'left', color: 'white', textShadow: '1px 1px 2px black' }} component="h2" gutterBottom>
                            WELCOME TO NUCLEUS <br /> THE UNIVERSAL COLLEGE LAHORE PORTAL
                        </Typography>


                    </Grid>
                    <Grid item xs={12} sm={5} md={5}>
                        <Grid item xs={12} sm={5} md={8} elevation={6} square style={{ alignContent: 'center', borderRadius: '18px', width: '95%', background: 'white', marginRight: '3%', marginTop: 85, marginBottom: '4%' }}>
                            <div component={Paper} elevation={6} className={classes.container}>
                                <div className={classes.container}>

                                    <div className={classes.paper}>
                                        {viewValue === 0 && <EmailVerification />}
                                        {viewValue === 1 && <CodeVerification />}
                                        {viewValue === 2 && <ChangePassword />}
                                    </div>


                                    <div style={{ paddingBottom: 25 }}>
                                        <Copyright />
                                    </div>
                                </div>

                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ForgotPassword;